import { LucideIcon } from 'lucide-react';

interface BadgeProps {
  icon?: LucideIcon;
  text: string;
  variant?: 'blue' | 'green' | 'purple' | 'gray';
}

export const Badge: React.FC<BadgeProps> = ({
  icon: Icon,
  text,
  variant = 'blue',
}) => {
  const variants = {
    blue: 'bg-blue-500/20 border-blue-500/30 text-blue-300',
    green: 'bg-green-500/20 border-green-500/30 text-green-300',
    purple: 'bg-purple-500/20 border-purple-500/30 text-purple-300',
    gray: 'bg-slate-500/20 border-slate-500/30 text-slate-300',
  };

  return (
    <div
      className={`
        inline-flex items-center gap-2
        px-4 py-2
        rounded-full
        border
        ${variants[variant]}
        text-sm font-medium
      `}
    >
      {Icon && <Icon size={16} />}
      <span>{text}</span>
    </div>
  );
};
